<template>
  <div style="padding: 20px 100px">
    <div class="style1">人社部：《人力资源服务机构管理规定》</div>

    <img src="static/assets/images/msg2.png" style="width: 600px;"/>
    <div class="style4">
      36月30日，贵州省发布《省人民政府关于促进高质量充分就业的意见》，鼓励支持灵活就业。
    </div>

    <div class="style4">
      相关要点：
    </div>

    <div class="style4">
      （十一）支持发展灵活就业和新就业形态。依托新产业新业态新商业模式，培育多元化多层次就业需求，
      鼓励劳动者通过互联网平台实现灵活就业。支持和规范发展新就业形态，发挥行业主管部门作用，
      加强对互联网平台企业用工的统计监测、管理监督和服务保障。
      鼓励有条件的地区每年按照不超过100元/人的标准给予新就业形态劳动者意外伤害商业保险补贴。
      就业困难人员和高校毕业生按规定在就业地申领灵活就业社会保险补贴。
    </div>

    <div class="style4">
      将灵活用工服务纳入就业公共服务范围，建设线上、线下零工市场，
      为有灵活就业意愿的失业人员与零工用人主体搭建高效、便捷“点对点”对接平台。
    </div>

    <div class="style4">
      完善线上服务平台。推动“互联网+就业公共服务”建设，优化贵州公共招聘网、贵州省劳务就业大数据平台业务系统服务功能，
      逐步实现重点业务线上经办，用人单位、劳动者服务需求线上申报。
      （责任单位：省人力资源社会保障厅、省大数据局）
    </div>

    <div class="style4">
      推进零工市场建设。
      2023年6月底前，各县（市、区、特区）至少建设1家线下或线上零工市场。
      建立全省零工市场名录并动态管理，适时向社会公布全省各类零工市场清单。
      支持基础较好的地区开展零工市场运行情况监测。
    </div>

  </div>

</template>

<script>
export default {
  mounted () {
    // 跳转后返回页面顶部
    window.scrollTo(0, 0)
  }
}
</script>

<style>
.style1{
  font-size: 20px;
  font-weight: 600;
  line-height: 80px;
}
.style2{
  font-size: 16px;
  line-height: 30px;
}
.style3{
  font-size: 16px;
  line-height: 30px;
}
.style4{
  font-size: 17px;
  line-height: 28px;
  margin: 20px 0;
}
.style5{
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin: 25px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/msg3.vue